import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Logging } from '~app/services/logging/logging.service';
import { Keyboard, KeyboardState, PaxEditConfirmed, PaxEditInfoUpdated, ResetContent } from '../../../../state';
import { AppRoutes } from '~app/app-routes';
import { AccessibilityService } from '~app/services/accessibility/accessibility.service';

@Component({
  selector: 'app-hawaiian-miles-entry',
  templateUrl: './hawaiian-miles-entry.component.html',
  styleUrls: ['./hawaiian-miles-entry.component.scss', '../../locate-reservation/locate-reservation.component.scss'],
})
export class HawaiianMilesEntryComponent implements OnInit, OnDestroy, AfterViewInit {
  keyboard$: Observable<Keyboard>;
  paxEditMainRoute = AppRoutes.PAX_EDIT_MAIN;

  public code = '';
  public codeDone = false;
  public keyboardSubscription: Subscription;

  constructor(
    private store: Store<KeyboardState>,
    private logging: Logging,
    private accessibilityService: AccessibilityService,
    private el: ElementRef
  ) {}

  ngOnInit() {
    this.logging.infoUiEnterHawaiianMilesPageDisplayed(0);
    this.store.dispatch(new ResetContent());
    this.keyboard$ = this.store.pipe(select('keyboard'));
    this.keyboardSubscription = this.keyboard$.subscribe((value) => {
      if (value) {
        this.code = value.content;
        this.codeDone = value.content.length === 9;
      }
    });
  }

  ngAfterViewInit(): void {
    this.getAcaaElements();
  }

  getAcaaElements() {
    let startIndex = 0;

    let sortedElements = this.el.nativeElement.querySelectorAll('[tabindex]');
    this.accessibilityService.setElementsToRead(sortedElements, startIndex);

    return sortedElements;
  }

  addHawaiianMiles() {
    if (this.codeDone) {
      this.logging.infoUiEnterHawaiianMilesPageContinueSelected();
      this.store.dispatch(new PaxEditInfoUpdated({ hawaiianMiles: this.code }));
      this.store.dispatch(new PaxEditConfirmed({ addHawaiianMiles: true }));
    }
  }

  ngOnDestroy() {
    if (this.keyboardSubscription) {
      this.keyboardSubscription.unsubscribe();
    }
  }
}
